import styled from "styled-components";

export const CardWrapper = styled.div`
  width: 100%;
`;

export const CardContent = styled.div`
  display: flex;
  align-items: center;
`;

export const LeadingIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 12px;
`;

export const ToolCardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  opacity: ${props => props.requiresSetup ? 0.6 : 1};
  filter: ${props => props.requiresSetup ? 'grayscale(0.3)' : 'none'};
  transition: opacity 0.2s ease, filter 0.2s ease;
`;

export const ToolCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TagContainer = styled.div`
  margin-left: 8px;
  opacity: 1 !important;
  filter: none !important;
  transform: translateZ(0); 
  isolation: isolate; 
  
  * {
    opacity: 1 !important;
    filter: none !important;
    transform: translateZ(0) !important;
  }
`;

export const TagSpacer = styled.div`
  margin-left: 8px;
`;

export const ToolCardDescription = styled.div`
  color: #666;
`;

export const ToolCardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

export const CircularIconButton = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #ccc;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f5f5f5;
    border-color: #999;
  }
  
  &:active {
    background: #e0e0e0;
  }
`;
